import s from "./_assocIndexOf.js";
var i = Array.prototype, l = i.splice;
function n(r) {
  var e = this.__data__, a = s(e, r);
  if (a < 0)
    return !1;
  var t = e.length - 1;
  return a == t ? e.pop() : l.call(e, a, 1), --this.size, !0;
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_listCacheDelete.js
// module id = 1529
// module chunks = 67